import type { BasicPricingValues } from "@slfinrtl/ui-bff-routes"
import type { CheckboxFieldProps } from "../../../form/checkbox/CheckboxField"
import type { InputFieldProps } from "../../../form/input/InputField"

export interface BasicPricingFields {
	minimumPrice: InputFieldProps
	price: InputFieldProps
	purchasePrice: InputFieldProps
	vatDeductible?: CheckboxFieldProps
}

type FieldName = keyof BasicPricingValues

const priceName: FieldName = "price"
const minimumPriceName: FieldName = "minimumPrice"
const purchasePriceName: FieldName = "purchasePrice"
const vatDeductibleName: FieldName = "vatDeductible"

export const basicPricingFieldNames = {
	minimumPriceName,
	priceName,
	purchasePriceName,
	vatDeductibleName,
}
